import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left explore-usecase-cta additional-resources-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "learn-more-with-these-additional-resources"
    }}>{`Learn more with these additional resources.`}</h2>
    <ResourceCard slots="link, image,text2, heading, text, buttons" width="25%" theme='lightest' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard resourceCardCont sales-cta ms-resource-card ms-resource-card-one" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": ""
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "80.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/e73542cfb6f7e9c3560e11a26f8fb582/5530d/Webinar_Thumbnail_Desktop.webp 320w", "/document-services/static/e73542cfb6f7e9c3560e11a26f8fb582/3c317/Webinar_Thumbnail_Desktop.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/e73542cfb6f7e9c3560e11a26f8fb582/8980b/Webinar_Thumbnail_Desktop.jpg 320w", "/document-services/static/e73542cfb6f7e9c3560e11a26f8fb582/74f5b/Webinar_Thumbnail_Desktop.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/e73542cfb6f7e9c3560e11a26f8fb582/74f5b/Webinar_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Webinar`}</p>
    <h3 {...{
      "id": "build-your-first-workflow"
    }}>{`Build your first workflow.`}</h3>
    <p>{`Watch our Document Automation 101 webinar to see how easy it is to get started building a workflow with Adobe and Microsoft.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/documentcloud/webinars/document-automation-101-building-your-first-workflow-with-adobe-and-microsoft.html"
        }}>{`Watch webinar`}</a></li>
    </ul>
    <ResourceCard slots="link, image, text2, heading, text, buttons" width="25%" theme='lightest' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard resourceCardCont rental-cta ms-resource-card ms-resource-card-two" mdxType="ResourceCard" />   
    <p><a parentName="p" {...{
        "href": ""
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "80.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/35903456be5c8084aa1f5634092e2f2e/5530d/DocWorkflow_Thumbnail_Desktop.webp 320w", "/document-services/static/35903456be5c8084aa1f5634092e2f2e/3c317/DocWorkflow_Thumbnail_Desktop.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/35903456be5c8084aa1f5634092e2f2e/8980b/DocWorkflow_Thumbnail_Desktop.jpg 320w", "/document-services/static/35903456be5c8084aa1f5634092e2f2e/74f5b/DocWorkflow_Thumbnail_Desktop.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/35903456be5c8084aa1f5634092e2f2e/74f5b/DocWorkflow_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Article`}</p>
    <h3 {...{
      "id": "create-a-document-workflow"
    }}>{`Create a document workflow.`}</h3>
    <p>{`Read how to build your first document workflow in Microsoft Power Automate.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/document-services/tutorials/pdfservices/create-workflow-power-automate.html?lang=en"
        }}>{`Read article`}</a></li>
    </ul>
    <ResourceCard slots="link, image, text2, heading, text, buttons" width="25%" theme='lightest' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard new-hire-cta ms-resource-card ms-resource-card-three" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": ""
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "80.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/36e8b07c62456c7f03a6ed33ceddb4b3/5530d/GettingStarted_Thumbnail_Desktop.webp 320w", "/document-services/static/36e8b07c62456c7f03a6ed33ceddb4b3/3c317/GettingStarted_Thumbnail_Desktop.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/36e8b07c62456c7f03a6ed33ceddb4b3/8980b/GettingStarted_Thumbnail_Desktop.jpg 320w", "/document-services/static/36e8b07c62456c7f03a6ed33ceddb4b3/74f5b/GettingStarted_Thumbnail_Desktop.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/36e8b07c62456c7f03a6ed33ceddb4b3/74f5b/GettingStarted_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Article`}</p>
    <h3 {...{
      "id": "getting-started-with-pdf-services"
    }}>{`Getting started with PDF Services.`}</h3>
    <p>{`Read how to get up and running in no time using the PDF services connector in Microsoft Power Automate.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/document-services/tutorials/pdfservices/getting-credentials-power-automate.html"
        }}>{`Read article`}</a></li>
    </ul>
    <ResourceCard slots="link, image, text2, heading, text, buttons" width="25%" theme='lightest' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard financial-cta ms-resource-card ms-resource-card-four" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": ""
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "80.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/e1309b8ad8198be3b41bb3f75569a661/5530d/CSUF_Thumbnail_Desktop.webp 320w", "/document-services/static/e1309b8ad8198be3b41bb3f75569a661/3c317/CSUF_Thumbnail_Desktop.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/e1309b8ad8198be3b41bb3f75569a661/8980b/CSUF_Thumbnail_Desktop.jpg 320w", "/document-services/static/e1309b8ad8198be3b41bb3f75569a661/74f5b/CSUF_Thumbnail_Desktop.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/e1309b8ad8198be3b41bb3f75569a661/74f5b/CSUF_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Customer story`}</p>
    <h3 {...{
      "id": "transform-digital-process"
    }}>{`Transform digital process.`}</h3>
    <p>{`See how CSU Fullerton is using Acrobat Sign and AEM Forms to transform digital processes across campus.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business.adobe.com/customer-success-stories/cal-state-fullerton-case-study.html"
        }}>{`Read story`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      